import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 100;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);
  return <header className="fixed top-0 left-0 w-full z-40 transition-all duration-500" data-id="element-43">
      <AnimatePresence mode="wait" data-id="element-44">
        {!scrolled ? <motion.nav key="fullNav" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.5
      }} className="container mx-auto px-4 py-6 flex items-center justify-between" data-id="element-45">
            <Link to="/" className="flex items-center" data-id="element-46">
              <div className="w-10 h-10 bg-[#39FF14] rounded-full flex items-center justify-center" data-id="element-47">
                <span className="text-black font-bold" data-id="element-48">HB</span>
              </div>
            </Link>
            <div className="hidden md:flex items-center space-x-8" data-id="element-49">
              <Link to="/" className="font-thin hover:text-[#39FF14] transition-colors" data-id="element-50">
                Home
              </Link>
              <Link to="/about" className="font-thin hover:text-[#39FF14] transition-colors" data-id="element-51">
                About
              </Link>
              <Link to="/skills" className="font-thin hover:text-[#39FF14] transition-colors" data-id="element-52">
                Skills
              </Link>
              <Link to="/services" className="font-thin hover:text-[#39FF14] transition-colors" data-id="element-53">
                Services
              </Link>
              <Link to="/contact" className="bg-[#39FF14] text-black px-4 py-2 rounded-full font-medium hover:bg-opacity-80 transition-all" data-id="element-54">
                Contact
              </Link>
            </div>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2" aria-label="Toggle menu" data-id="element-55">
              {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-56" /> : <MenuIcon className="w-6 h-6" data-id="element-57" />}
            </button>
          </motion.nav> : <motion.div key="minimalNav" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.5
      }} className="flex justify-center py-4" data-id="element-58">
            <div className="bg-black dark:bg-white bg-opacity-10 dark:bg-opacity-10 backdrop-blur-md px-6 py-2 rounded-full flex items-center space-x-2" data-id="element-59">
              <div className="w-6 h-6 bg-[#39FF14] rounded-full flex items-center justify-center" data-id="element-60">
                <span className="text-black text-xs font-bold" data-id="element-61">HB</span>
              </div>
              <span className="font-thin text-sm" data-id="element-62">Available for work</span>
              <div className="w-2 h-2 rounded-full bg-[#39FF14] animate-pulse" data-id="element-63"></div>
            </div>
          </motion.div>}
      </AnimatePresence>
      <AnimatePresence data-id="element-64">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        x: '100%'
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: '100%'
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 bg-white dark:bg-black z-50 md:hidden" data-id="element-65">
            <div className="container mx-auto px-4 py-6 flex items-center justify-between" data-id="element-66">
              <Link to="/" className="flex items-center" data-id="element-67">
                <div className="w-10 h-10 bg-[#39FF14] rounded-full flex items-center justify-center" data-id="element-68">
                  <span className="text-black font-bold" data-id="element-69">HB</span>
                </div>
              </Link>
              <button onClick={() => setMobileMenuOpen(false)} className="p-2" aria-label="Close menu" data-id="element-70">
                <XIcon className="w-6 h-6" data-id="element-71" />
              </button>
            </div>
            <div className="flex flex-col items-center justify-center h-[calc(100vh-100px)] space-y-8" data-id="element-72">
              <Link to="/" className="text-2xl font-thin hover:text-[#39FF14] transition-colors" data-id="element-73">
                Home
              </Link>
              <Link to="/about" className="text-2xl font-thin hover:text-[#39FF14] transition-colors" data-id="element-74">
                About
              </Link>
              <Link to="/skills" className="text-2xl font-thin hover:text-[#39FF14] transition-colors" data-id="element-75">
                Skills
              </Link>
              <Link to="/services" className="text-2xl font-thin hover:text-[#39FF14] transition-colors" data-id="element-76">
                Services
              </Link>
              <Link to="/contact" className="bg-[#39FF14] text-black px-8 py-3 rounded-full font-medium hover:bg-opacity-80 transition-all text-2xl" data-id="element-77">
                Contact
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
};
export default Header;